<template>
  <div v-if="visible" class="document-dialog-overlay" @click.self="handleCancel">
    <div class="document-dialog">
      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleCancel">
        <span>×</span>
      </div>
      <!-- 文档内容区域 - PDF显示 -->
      <div class="document-content" ref="contentRef">
        <div v-if="pdfUrl" class="pdf-container">
          <iframe
            :src="pdfUrl"
            class="pdf-iframe"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      
      <!-- 底部操作区域 -->
      <div class="document-footer">
        <div class="footer-buttons">
          <button class="btn-submit" :disabled="countdown > 0" @click="handleSubmit">{{countdown>0?'请仔细阅读以上内容（'+countdown+'秒）':'阅读并同意'}} </button>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    documentData: {
      type: Object,
      default: () => ({
        name: '',
        url: '' // PDF文件URL
      })
    },
    countdownSeconds: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      countdown: 5,
      timer: null
    }
  },
  computed: {
    pdfUrl() {
      let url = this.documentData.attUrl || this.documentData.url;
      if (url) {
        if (!url.startsWith('http://') && !url.startsWith('https://') && !url.startsWith('//')) {
          if (url.startsWith('/')) {
            url = window.location.origin + url
          }
        }
        // 添加参数隐藏缩略图（navpanes=0），保持视图适合宽度
        const hashIndex = url.indexOf('#')
        if (hashIndex === -1) {
          // 没有 # 参数，直接添加
          url += '#view=FitH&navpanes=0'
        } else {
          // 已有 # 参数，检查并添加 navpanes=0
          const hashPart = url.substring(hashIndex + 1)
          if (!hashPart.includes('navpanes=')) {
            // 如果 hashPart 为空或已有其他参数，使用 & 连接
            url += (hashPart && !hashPart.endsWith('&') ? '&' : '') + 'navpanes=0'
          } else {
            // 如果已有 navpanes 参数，替换为 0
            url = url.replace(/navpanes=\d+/g, 'navpanes=0')
          }
        }
      }
      
      return url
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.startCountdown()
      } else {
        this.clearCountdown()
      }
    }
  },
  methods: {
    startCountdown() {
      this.countdown = this.countdownSeconds
      this.clearCountdown()
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.clearCountdown()
        }
      }, 1000)
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleSubmit() {
      if (this.countdown > 0) {
        return
      }
      this.$emit('submit')
    },
    isUrl(str) {
      if (typeof str !== 'string') return false
      // 简单判断是否为URL
      return /^https?:\/\//.test(str.trim()) || /\.pdf$/i.test(str)
    }
  },
  beforeDestroy() {
    this.clearCountdown()
  }
}
</script>

<style lang="scss" scoped>
.document-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.document-dialog {
  position: relative;
  width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 5px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  color: #666;
  font-size: 24px;
  line-height: 1;
  transition: color 0.3s;
  
  &:hover {
    color: #333;
  }
  
  span {
    display: block;
  }
}



.document-content {
  box-sizing: border-box;
  padding: 20px 40px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fff;
  height: 80vh;
  border-radius: 10px;
}

.pdf-container {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.pdf-loading {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 14px;
  
  p {
    margin: 0;
  }
}

.document-footer {
  padding: 20px 40px 30px;
  border-top: 1px solid #f0f0f0;
}

.footer-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn-submit {
  width: 330px;
  height: 40px;
  background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
  box-shadow: 0px 4px 10px 0px rgba(63,107,187,0.5);
  border-radius: 10px 10px 10px 10px;
  color: #fff;
  border: none;
  cursor: pointer;
  &:hover:not(:disabled) {
    opacity: 0.9;
    transform: translateY(-1px);
  }
  
  &:disabled {
    cursor: not-allowed;
  }
}



</style>
